import React, { Component } from 'react';
import { connect } from 'react-redux';
import ContentWithNavigationSidebar from 'legacy/layouts/ContentWithNavigationSidebar';
import ContentHeader from 'legacy/containers/ContentHeader';
import { UserProfileContext } from 'auth/contexts/UserProfileContext';
import { clearSearchResults } from 'state/reducers/search/searchActions';
import {
  SEARCH_FORM_REDUCERS,
  SEARCH_REDUCERS,
} from 'state/reducers/search/searchReducers';
import { DATASOURCES, getDataSource } from 'state/services/utils';
import { injectIntl } from 'react-intl';
import { checkRpmFeatureEnabled } from 'configs';
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent';
import EcgLoader from 'legacy/containers/EcgLoader';
import PatientSearchBar from '../../containers/Search/PatientSearchBar';
import PatientSearchResults from '../../containers/Search/PatientSearchResults';

import styles from './PagePatientSearch.css';

class PagePatientSearch extends Component {
  constructor(props) {
    super(props);

    this.refCallback = this.refCallback.bind(this);
  }

  componentDidMount() {
    if (!this.context.hasUserData()) {
      // make sure it's empty and not cached from previous navigations.
      // Use case: user logging in. During this flow the user profile is cleared.
      this.props.dispatch(clearSearchResults());
    }
  }

  refCallback = element => {
    if (element) {
      this.containerEle = element;
    }
  };

  render() {
    const { me, intl } = this.props;
    if (!checkRpmFeatureEnabled(me)) {
      return (
        <ContentWithNavigationSidebar>
          <div data-page="patient-search" className={styles.patientSearchPage}>
            <AccessDeniedContent
              title={intl.formatMessage({ id: 'search.PageTitle' })}
            />
          </div>
        </ContentWithNavigationSidebar>
      );
    }

    return (
      <ContentWithNavigationSidebar>
        <div data-page="patient-search" className={styles.patientSearchPage}>
          <ContentHeader
            showLastRefresh={false}
            text={intl.formatMessage({ id: 'search.PageTitle' })}
            me={me}
          />
          {me.isFetching ? (
            <EcgLoader />
          ) : (
            <React.Fragment>
              <PatientSearchBar />
              <section
                ref={this.refCallback}
                className={styles.patientSearchResultsContainer}
              >
                <PatientSearchResults me={me} />
              </section>
            </React.Fragment>
          )}
        </div>
      </ContentWithNavigationSidebar>
    );
  }
}
PagePatientSearch.contextType = UserProfileContext;
const mapStateToProps = state => {
  const me = getDataSource(state, DATASOURCES.ME);
  const { form, search } = state;

  return {
    searchBarFields: search[SEARCH_REDUCERS.SEARCH_BAR_FIELDS],
    patientSearchForm: form[SEARCH_FORM_REDUCERS.PATIENT_SEARCH],
    searchForceRefresh: search[SEARCH_REDUCERS.SEARCH_FORCE_REFRESH],
    me,
  };
};

export default connect(mapStateToProps)(injectIntl(PagePatientSearch));



// WEBPACK FOOTER //
// ./src/views/pages/PatientSearch/PagePatientSearch.jsx